import { Haptics, ImpactStyle } from "@capacitor/haptics";
import {
  Box,
  Flex,
  Icon,
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  useDisclosure,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Edit, Search } from "../icons/icons";
import ShareModal from "../modals/ShareModal";
import { useUserWrapperContext } from "../wrappers/UserWrapper";

const UserMessagesSearchHeader = () => {
  const { topCollapsed, currentChat, setCurrentChat, search, setSearch } =
    useUserWrapperContext();

  const transition = "0.2s ease-out";
  const navigate = useNavigate();

  const {
    isOpen: isNewMesageModalOpen,
    onClose: onNewMesageModalClose,
    onOpen: onNewMesageModalOpen,
  } = useDisclosure();

  const triggerHapticFeedback = async (style = ImpactStyle.Heavy) => {
    Haptics.impact({ style }).catch(() => {})
  };

  return (
    <>
      {currentChat.length == 0 ? (
        <Box m="9px 20px" transition="0">
          <ShareModal
            isOpen={isNewMesageModalOpen}
            onClose={onNewMesageModalClose}
            onExtendShare={(users: any[]) => {
              onNewMesageModalClose();
              triggerHapticFeedback(ImpactStyle.Medium);

              /* CHANGING */
              setCurrentChat(users);
            }}
            title="New message"
          />
          <Flex
            h={topCollapsed ? "0" : "40px"}
            mb={topCollapsed ? "0" : "10px"}
            justifyContent="space-between"
            transition={transition}
            overflow="hidden"
          >
            <IconButton
              minW="34px"
              h="34px"
              variant="light"
              aria-label="new chat"
              onClick={() => {
                currentChat.length > 0 ? setCurrentChat(null) : navigate(-1);
                triggerHapticFeedback(ImpactStyle.Medium);
              }}
              icon={
                <Icon width="20px" height="19px" viewBox="0 0 23 20">
                  <ArrowLeft color="#171C22" />
                </Icon>
              }
            />
            <IconButton
              minW="34px"
              h="34px"
              variant="light"
              aria-label="new chat"
              icon={
                <Icon width="18px" height="18px" viewBox="0 0 24 24">
                  <Edit color="#171C22" />
                </Icon>
              }
              onClick={() => {
                onNewMesageModalOpen();
                triggerHapticFeedback(ImpactStyle.Medium);
              }}
            />
          </Flex>
          <Box>
            {currentChat.length > 0 ? (
              <></>
            ) : (
              <InputGroup>
                <InputLeftElement>
                  <Icon width="18" height="18" viewBox="0 0 18 18">
                    <Search color="#7E8B9A" />
                  </Icon>
                </InputLeftElement>
                <Input
                  w="100%"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  variant="filled"
                  placeholder="Search or start a new chat..."
                />
              </InputGroup>
            )}
          </Box>
        </Box>
      ) : (
        <></>
      )}
    </>
  );
};

export default UserMessagesSearchHeader;
